// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bookmark';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.938 1.687h-2.25A1.125 1.125 0 0 0 .563 2.812v13.5a1.125 1.125 0 0 0 1.125 1.125h14.624a1.125 1.125 0 0 0 1.125-1.125v-13.5a1.125 1.125 0 0 0-1.125-1.125H8.438' />
    <path d='M8.438 8.437 6.188 6.75l-2.25 1.688V1.125A.563.563 0 0 1 4.5.562h3.375a.563.563 0 0 1 .563.562zm-4.5 5.625h7.874m-7.874-3.375h10.124m.001-3.375h-3.376' />
  </g>
);

export const viewBox = '0 0 18 18';
